import {
  ChangeEventHandler,
  FocusEventHandler,
  InputHTMLAttributes
} from 'react'

import * as S from './styles'

type InputTypes = InputHTMLAttributes<HTMLInputElement>

type InputProps = {
  label?: any
  labelColor?: string
  type: string
  hasNotArrowNumber?: boolean
  name: string
  placeholder?: string
  hasTestInput?: boolean
  hasQuestionInput?: boolean
  error?: string
  required?: boolean
  value?: string | number
  onChange?: ChangeEventHandler | undefined
  onBlur?: FocusEventHandler | undefined
  wrapperClassName?: string
} & InputTypes

const Input = ({
  wrapperClassName,
  label,
  labelColor,
  hasTestInput = false,
  hasQuestionInput = false,
  hasNotArrowNumber = false,
  type,
  name,
  value,
  required,
  onChange,
  error,
  onBlur,
  ...props
}: InputProps) => (
  <S.Wrapper
    className={wrapperClassName}
    hasQuestionInput={hasQuestionInput}
    hasTestInput={hasTestInput}
    hasNotArrowNumber={hasNotArrowNumber}
  >
    <label style={{ color: labelColor }} htmlFor={name}>
      {label}
    </label>
    <input
      required={required}
      type={type}
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      {...props}
    />
    {error && <p className="error">{error}</p>}
  </S.Wrapper>
)

export default Input
